<template>
  <v-container
    fluid
    class="bg"
    align-center
    fill-height
    style="display:flex; justify-content:center;"
    pt-0
    mt-0
  >
    <v-responsive height="100%" class="hidden-sm-and-down">
      <v-container fluid fill-height pb-0>
        <v-layout align-center justify-space-around column mb-5>
          <v-flex
            xs12
            md12
            style="display: flex; flex-flow: column;width: 100%;"
          >
            <v-layout wrap justify-center>
              <v-flex xs12 md12 sm12>
                <img
                  src="../assets/images/logo-main.png"
                  alt=""
                  :width="imageHeight"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center mb-2>
              <v-flex md12 sm9 xs12>
                <h3 class="display-3 line95 font-shadow font-weight-bold mt-0">
                  โครงการและกิจกรรมปลูกต้นไม้และปลูกป่าเฉลิมพระเกียรติ
                </h3>
                <h3 class="display-3 font-shadow font-weight-bold mt-0 mb-1">
                  เนื่องในโอกาสมหามงคลพระราชพิธีบรมราชาภิเษก
                </h3>
                <h3
                  class="display-2 font-shadow3 font-weight-bold mb-2"
                  style="line-height: 35px;"
                >
                  "รวมใจไทย ปลูกต้นไม้ เพื่อแผ่นดิน สืบสานสู่ ๑๐๐ ล้านต้น"
                </h3>
                <!-- <h3 class="display-2 font-shadow font-weight-bold mt-0">เนื่องในโอกาสมหามงคลพระราชพิธีบรมราชาภิเษก</h3> -->
                <div style="display:flex">
                  <h3 class="headline font-shadow2">
                    จำนวนต้นไม้ที่ลงทะเบียนแล้ว&nbsp;
                  </h3>
                  <h3 class="el headline font-shadow2" v-if="value !== ''"></h3>
                  <v-progress-circular
                    v-else
                    indeterminate
                    :value="20"
                    :width="3"
                    :size="20"
                    color="white"
                    class="mt-1"
                  >
                  </v-progress-circular>
                </div>
                <v-divider class="my-3"></v-divider>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-start>
              <v-flex md3 sm12 xs12>
                <v-btn
                  class="mx-0"
                  round
                  block
                  color="primary"
                  @click="gotoIndex()"
                >
                  <p style="font-size:23px;margin-bottom:0px">ร่วมปลูกต้นไม้</p>
                </v-btn>
                <div style="text-align:center;">
                  <!-- <v-btn flat round href="https://plant.forest.go.th/static/plant-knowledge/manual.pdf" target="_blank"><v-icon class="mr-1">chrome_reader_mode</v-icon>คู่มือการใช้งาน</v-btn> -->
                </div>
                <!-- <img src="../assets/images/logo.png" alt="" width="300px"> -->
                <img
                  src="../assets/images/logo12com_desktop.png"
                  alt=""
                  width="900"
                />
              </v-flex>
            </v-layout>
            <!-- <v-layout row wrap>
      <v-flex xs12 md12 sm12 style="justify-content: center;display:flex;align-items:flex-end" class="footer">
        <span style="font-size: 22px; text-decoration: underline; cursor: pointer" @click="gotoIndex()">เข้าสู่เว็บไซต์</span>
      </v-flex>
      </v-layout> -->
          </v-flex>
        </v-layout>
        <!-- <div class="footer">
    <span style="font-size: 22px; text-decoration: underline; cursor: pointer" @click="gotoIndex()">เข้าสู่เว็บไซต์</span>
  </div> -->
      </v-container>
    </v-responsive>

    <v-responsive height="100%" class="hidden-md-and-up">
      <v-container fluid fill-height justify-center align-center pb-0 pt-0>
        <v-layout align-center justify-space-around column>
          <v-flex
            xs12
            md12
            style="display: flex; flex-flow: column;width: 100%;"
          >
            <v-layout row wrap justify-center>
              <v-flex xs12 md12 sm12 style="text-align:center;">
                <v-img
                  :src="require('../assets/images/logo-main.png')"
                  alt=""
                  :height="imageHeight"
                  contain
                ></v-img>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
              <v-flex md12 sm9 xs12>
                <h3
                  class="font-for-mobile-main font-shadow font-weight-bold mt-0"
                >
                  โครงการและกิจกรรมปลูกต้นไม้
                </h3>
                <h3
                  class="font-for-mobile-main font-shadow font-weight-bold mt-0 mb-1"
                >
                  และปลูกป่าเฉลิมพระเกียรติ
                </h3>
                <h3
                  class="font-for-mobile-middle font-shadow font-weight-bold mt-0 mb-2"
                >
                  เนื่องในโอกาสมหามงคลพระราชพิธีบรมราชาภิเษก
                </h3>
                <h3
                  class="line37 font-for-mobile-sub font-shadow3 font-weight-bold mb-1 mt-2"
                  style="line-height: 35px;"
                >
                  "รวมใจไทย ปลูกต้นไม้ เพื่อแผ่นดิน<br />สืบสานสู่ ๑๐๐ ล้านต้น"
                </h3>
                <!-- <h3 class="font-shadow font-weight-bold mb-3" style="white-space: nowrap;font-size:19px !important">เนื่องในโอกาสมหามงคลพระราชพิธีบรมราชาภิเษก</h3> -->

                <div style="display:flex">
                  <h3 class="title font-shadow2">
                    จำนวนต้นไม้ที่ลงทะเบียนแล้ว&nbsp;
                  </h3>
                  <h3 class="el title font-shadow2" v-if="value !== ''"></h3>
                  <v-progress-circular
                    v-else
                    indeterminate
                    :value="20"
                    :width="3"
                    :size="20"
                    color="white"
                    class="mt-1"
                  >
                  </v-progress-circular>
                </div>
                <v-divider class="my-3"></v-divider>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
              <v-flex md12 sm9 xs12>
                <v-btn
                  class="mx-0"
                  round
                  block
                  color="primary"
                  @click="gotoIndex()"
                >
                  <p class="mb-0">ร่วมปลูกต้นไม้</p>
                </v-btn>
                <!-- <v-btn flat round href="https://plant.forest.go.th/static/plant-knowledge/manual.pdf" target="_blank" color="white"><v-icon class="mr-1">chrome_reader_mode</v-icon>คู่มือการใช้งาน!-->
                <!-- <div class=""> -->
                <!-- <img src="../assets/images/logo.png" alt="" width="290"> -->
                <!-- </div> -->
                <div class="pt-2">
                  <img
                    src="../assets/images/logo12com_mobile.png"
                    alt=""
                    width="290"
                  />
                </div>
              </v-flex>
            </v-layout>
            <!-- <v-layout row wrap>
      <v-flex xs12 md12 sm12 style="justify-content: center;display:flex;align-items:flex-end">
        <span style="font-size: 20px; text-decoration: underline; cursor: pointer;font-weight: bold;" @click="gotoIndex()">เข้าสู่เว็บไซต์</span>
      </v-flex>
      </v-layout> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-responsive>
  </v-container>
</template>

<script>
var $ = require("jquery");
export default {
  data() {
    return {
      value: "",
      startValue: 0
    };
  },
  created() {
    // this.queryStat()
    // this.showAlert()
  },
  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "140px";
        case "sm":
          return "180px";
        case "md":
          return "150px";
        case "lg":
          return "150px";
        case "xl":
          return "180px";
      }
    }
  },
  mounted() {
    var me = this;
    this.queryStat().then(() => {
      $({ someValue: me.startValue }).animate(
        { someValue: me.value },
        {
          duration: 1000,
          easing: "swing", // can be anything
          step: function() {
            // called on every step
            // Update the element's text with rounded-up value
            $(".el").text(
              me.commaSeparateNumber(Math.round(this.someValue)) + " ต้น"
            );
          },
          complete: () => {
            $(".el").text(
              me.commaSeparateNumber(Math.round(me.value)) + " ต้น"
            );
          }
        }
      );
    });
  },
  methods: {
    // showAlert(){
    //   // this.$swal('กรมป่าไม้จะดำเนินการปิดปรับปรุงระบบ <br>ในวันที่ 7 มิถุนายน 2562 เวลา 17.00 น. เป็นต้นไป <br>และจะเปิดให้ใช้งานได้อีกครั้ง<br>ในวันที่ 8 มิถุนายน 2562 เวลา 10.00 น. <br>ขออภัยในความไม่สะดวก','','');
    //   this.$swal({
    //     // imageUrl: 'https://placeholder.pics/svg/400x200',
    //     imageUrl: require('../assets/images/announce.jpeg'),
    //     imageHeight: 300,
    //     type: '',
    //     width: 560,
    //     title: 'แจ้งปิดปรับปรุงระบบ',
    //     html: '<strong>เว็บไซต์รวมใจไทย ปลูกต้นไม้ เพื่อแผ่นดิน<br>ในวันศุกร์ที่ 7 มิถุนายน 2562 เวลา 17.00 น. เป็นต้นไป กรมป่าไม้จะดำเนินการย้ายระบบไปไว้บนคลาวด์ เพื่อเพิ่มประสิทธิภาพในการให้บริการ โดยจะไม่สามารถบันทึกข้อมูลการปลูกต้นไม้ในเว็บไซต์ได้ และเปิดให้บริการอีกครั้งในวันเสาร์ที่ 8 มิถุนายน 2562 เวลา 10.00 น. เป็นต้นไป จึงขออภัยในความไม่สะดวก',
    //     confirmButtonText:'ปิดหน้าต่าง',
    //     allowOutsideClick: false
    //   })
    // },
    gotoIndex() {
      this.$router.push("/seeding");
    },
    queryStat() {
      return new Promise((resolve) => {
        this.axios
          .post(process.env.VUE_APP_IPFLASK + "/totalUserPlant")
          .then((response) => {
            this.value = response.data[0].totalUserPlant;
            // console.log(this.value);
            // this.value = "";
            this.startValue = this.value / 10;
            resolve();
          });
      });
    },
    commaSeparateNumber(val) {
      while (/(\d+)(\d{3})/.test(val.toString())) {
        val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
      return val;
    }
  }
};
</script>

<style scoped>
.bg {
  background-image: url("../assets/images/bg7.jpg");
  background-size: cover;
  /* background-position: top; */
  /* background-repeat: repeat-x; */
}

.font-shadow {
  text-shadow: 1px 1px 10px rgb(255, 255, 255);
  color: #a07b49;
  font-size: 52px !important;
}
.font-shadow2 {
  text-shadow: 1px 1px 11px rgb(255, 255, 255);
  color: #824a00;
}
.font-shadow3 {
  text-shadow: 1px 1px 11px rgb(255, 255, 255);
  color: #984d00;
  font-size: 44px !important;
  letter-spacing: 0px !important;
}

.footer {
  font-weight: 700;
  bottom: 0;
  text-align: center;
  width: 100%;
}

.display-1 {
  line-height: 30px !important;
}
/* .line37{
    line-height: 42px !important;
  } */
.font100 {
  font-size: 82px !important;
  line-height: 80px !important;
}

.line95 {
  line-height: 0.6 !important;
}

@media only screen and (max-width: 320px) {
  .font-for-mobile-main {
    font-size: 22px !important;
    line-height: 19px !important;
  }
  .font-for-mobile-middle {
    font-size: 19px !important;
    line-height: 18px;
  }
  .font-for-mobile-sub {
    font-size: 20px !important;
    line-height: 19px !important;
  }
}

@media only screen and (min-width: 321px) and (max-width: 600px) {
  .font-for-mobile-main {
    font-size: 26px !important;
    line-height: 26px;
  }
  .font-for-mobile-middle {
    font-size: 22px !important;
    line-height: 20px;
  }
  .font-for-mobile-sub {
    font-size: 26px !important;
    line-height: 42px !important;
  }
}

@media only screen and (min-width: 601px) {
  .font-for-mobile-main {
    font-size: 38px !important;
    line-height: 40px !important;
  }
  .font-for-mobile-middle {
    font-size: 30px !important;
    /* line-height: 20px; */
    /* margin-top: 5px !important; */
  }
  .font-for-mobile-sub {
    font-size: 38px !important;
    /* line-height: 20px !important; */
    margin-bottom: 10px;
  }
}
</style>
